const MARKDOWN_TABLE_SEPARATOR = /^\s*\|?\s*:?-{3,}:?\s*(?:\|\s*:?-{3,}:?\s*)+\|?\s*$/;
const HORIZONTAL_RULE = /^\s*(?:[-*_]\s*){3,}$/;
const VISUAL_ONLY_ALT_WORDS = new Set([
    'icon', 'emoji', 'arrow', 'check', 'checkmark', 'cross', 'x',
    'up', 'down', 'left', 'right', 'symbol', 'glyph',
]);

function narrationImageAlt(alt) {
    const words = alt
        .normalize('NFKC')
        .toLocaleLowerCase('en-US')
        .replace(/[-_]+/g, ' ')
        .replace(/[^\p{L}\p{N}\s]/gu, ' ')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    return words.length > 0 && words.every(word => VISUAL_ONLY_ALT_WORDS.has(word)) ? ' ' : alt;
}

/** Convert displayed Markdown into plain, speakable prose without naming icons. */
export function sanitizeNarration(value) {
    if (typeof value !== 'string' || !value) return '';

    const lines = value
        .replace(/```(?:[^\n]*)\n?/g, '\n')
        .split(/\r?\n/)
        .filter(line => !MARKDOWN_TABLE_SEPARATOR.test(line) && !HORIZONTAL_RULE.test(line))
        .map(line => line
            // Retain prose accessibility labels, never the visual asset or URL.
            .replace(/!\[([^\]]*)\]\([^)]*\)/g, (_match, alt) => narrationImageAlt(alt))
            .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
            .replace(/<https?:\/\/[^>]+>/gi, ' ')
            .replace(/https?:\/\/\S+/gi, ' ')
            // Remove structural Markdown while leaving its meaningful text.
            .replace(/^\s*#{1,6}\s+/, '')
            .replace(/^\s*>+\s?/, '')
            .replace(/^\s*[-+*]\s+\[[ xX]\]\s*/, '')
            .replace(/^\s*(?:[-+*]|\d+[.)])\s+/, '')
            .replace(/[`*_~]+/g, ' ')
            .replace(/[\[\]{}]/g, ' ')
            .replace(/\|/g, ' ')
            // Visual-only Unicode is a separator, never a spoken symbol name.
            .replace(/<=>|<->|=>|->|<-/g, ' ')
            .replace(/[←-⇿⬀-⬿⟰-⟿]/gu, ' ')
            .replace(/[•‣⁃◦∙⋅·]/gu, ' ')
            .replace(/[☑☒✓✔✕✖✗✘❌✅]/gu, ' ')
            .replace(/\p{Extended_Pictographic}/gu, ' ')
            .replace(/[☀-⛿✀-➿■-◿]/gu, ' ')
            .replace(/[\u{1F1E6}-\u{1F1FF}\u{1F300}-\u{1FAFF}\u{1F3FB}-\u{1F3FF}\u20E3]/gu, ' ')
            .replace(/[\uFE0E\uFE0F\u200D]/g, ' ')
            .replace(/\s+/g, ' ')
            .replace(/\s+([,.;:?!])/g, '$1')
            .trim())
        .filter(Boolean);

    return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
}
